import { colours } from '../../_styleguide/_colours';
import * as d3 from 'd3';
var ChartLineVV = /** @class */ (function () {
    function ChartLineVV(ctrlr, yParameter, colour) {
        this.ctrlr = ctrlr;
        this.yParameter = yParameter;
        this.colour = colour;
    }
    ChartLineVV.prototype.draw = function (data) {
        var yParameter = this.ctrlr.parameters[this.yParameter] != undefined ? this.ctrlr.parameters[this.yParameter] : this.yParameter;
        this.line = this.ctrlr.svg.layers.data.selectAll('.vastevergoeding')
            .data([data.slice])
            .join("path")
            .attr("class", 'vastevergoeding')
            .attr("stroke-dasharray", "2 4");
        this.label = this.ctrlr.svg.layers.data
            .append("text")
            .text("vv")
            .attr("text-anchor", "start");
    };
    ChartLineVV.prototype.lineMaker = function () {
        var _this = this;
        var yParameter = this.ctrlr.parameters[this.yParameter] != undefined ? this.ctrlr.parameters[this.yParameter] : this.yParameter;
        return d3.line()
            .x(function (d) { return _this.ctrlr.scales.x.scale(d[_this.ctrlr.parameters.x]); })
            .y(function (d) { return _this.ctrlr.scales.y.scale(5000); })
            .curve(d3.curveBasis);
    };
    ChartLineVV.prototype.redraw = function () {
        var _this = this;
        var self = this;
        this.line
            .transition()
            .duration(250)
            .attr("d", this.lineMaker())
            .attr("fill", 'transparent')
            .attr("stroke", function (d) { return colours[_this.colour][0]; })
            .attr("stroke-width", 1);
        this.label
            .attr("dx", 4)
            .attr("dy", 4)
            .style('font-size', '.66rem')
            .attr('fill', colours[this.colour][0])
            .style('text-transform', 'lowercase')
            .attr("transform", "translate(" + this.ctrlr.dimensions.width + "," + this.ctrlr.scales.y.scale(5000) + ")");
    };
    return ChartLineVV;
}());
export { ChartLineVV };
